import UserStorage from './UserStorage';

const RouteData = {
    localRoute:[{
        id:'/',
        path: '/',
        name: 'home', 
        pageUrl: '/Home',
        url: '/',
        permission:'首页',
        redirect:'/dashboard',
        children:[
            {
                id:'/console',
                path: '/console',
                name:'console',
                pageUrl:'/Console',
                url:'/console',
                permission:'控制台'
            },
            {
                id:'/dashboard',
                path: '/dashboard',
                name:'dashboard',
                pageUrl:'/Dashboard',
                url:'/dashboard',
                permission:'仪表盘'
            }
        ]
    }, 
    {
        id: '/login',
        name:'login',
        path: '/login',
        pageUrl: '/Login',
        url: '/login', 
        permission: '登录'
    }],
    buildRoute:function(item,level){
        let route = {  
            path: item.id,
            component:() => import('../components' + item.pageUrl + '.vue'),
            meta:{
                title:item.permission,
                name:item.permission,
                id:item.id,
                url:item.url,
                level:level
            }
        };
        
        // 如果有重定向属性，则添加到路由配置中
        if(item.redirect) {
            route.redirect = item.redirect;
        }
        
        return route;
    },
    getLocalRoute(){
        return this.localRoute;
    },
    createRoutes:function(){
        let localRouteArray = UserStorage.getRouteInfo();
        if(localRouteArray == null || localRouteArray.length == 0) localRouteArray = this.localRoute;

        let result = [];
        for(let i = 0;i<localRouteArray.length;i++){
            let item = localRouteArray[i];
            let route = this.buildRoute(item,0);
            route.children = [];
            if(item.hasOwnProperty('children')){
                for(let n = 0;n<item.children.length;n++){
                    let sub = item.children[n];
                    route.children.push(this.buildRoute(sub,1));
                }
            }
           result.push(route);
        } 
        return result;
    }
};

export default RouteData;
  